import { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
 const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedGenre, setSelectedGenre] = useState("");
  const [selectedAge, setSelectedAge] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedSort, setSelectedSort] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryName, setSearchQueryName] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsName, setSuggestionsName] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [expandedFilter, setExpandedFilter] = useState(null);

  // Optional: store previous scroll or pagination
  const [visibleCount, setVisibleCount] = useState(0);

  const resetFilters = () => {
    setSelectedMonth("");
    setSelectedGenre("");
    setSelectedAge("");
    setSelectedType("");
    setSelectedLanguage("");
    setSelectedSort("");
    setSearchQuery("");
    setSearchQueryName("");
    setSuggestions([]);
    setSuggestionsName([]);
    setVisibleCount(0);
  };

  return (
    <AppContext.Provider
      value={{
        selectedMonth,
        setSelectedMonth,
        selectedGenre,
        setSelectedGenre,
        selectedAge,
        setSelectedAge,
        selectedType,
        setSelectedType,
        selectedLanguage,
        setSelectedLanguage,
        selectedSort,
        setSelectedSort,
        searchQuery,
        setSearchQuery,
        searchQueryName,
        setSearchQueryName,
        suggestions,
        setSuggestions,
        suggestionsName,
        setSuggestionsName,
        showPopup,
        setShowPopup,
        expandedFilter,
        setExpandedFilter,
        visibleCount,
        setVisibleCount,
        resetFilters,loading, setLoading 
      }}
  >
            {children}
        </AppContext.Provider>
    );
};

// Custom hook
export const useApp = () => useContext(AppContext);
